import { REPORT_TEMPLATE } from "@common/flags"
import { createFileRoute } from "@tanstack/react-router"
import { requireFeatureFlag } from "@/lib/require-feature-flag"
import { requirePermission } from "@/lib/require-permission"
import { TEMPLATES_PERMISSION } from "./-lib/kinds"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/templates",
)({
  staticData: {
    breadcrumb: [
      {
        label: "Workspace - Templates",
        href: "/settings/workspace/templates",
      },
    ],
  },
  beforeLoad: async ({ context: { queryClient } }) => {
    await requireFeatureFlag(queryClient, REPORT_TEMPLATE)
    await requirePermission(
      queryClient,
      TEMPLATES_PERMISSION,
      "/settings/workspace/general",
    )
  },
})
